<template>

    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
            <v-toolbar dark color="primary" style="position: sticky; top: 0; z-index: 1">
                <v-btn icon dark @click="close"><v-icon>mdi-close</v-icon></v-btn>
                <v-toolbar-title>{{ baixa ? 'Baixar' : item.id > 0 ? 'Editar' : 'Novo'}} Recebível</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn dark text @click="save" :disabled="!valid">{{ baixa ? 'Baixar' : 'Salvar'}}</v-btn>
                </v-toolbar-items>
            </v-toolbar>

            <v-card-text class="mt-5">
                <v-form ref="formCadastroRecebivel" v-model="valid" lazy-validation>
                    <v-row>
                        <v-col cols="12" md="2">
                            <v-text-field type="number" v-model.number="item.id" label="Documento" disabled dense outlined/>
                        </v-col>
                        <v-col cols="12" md="5">
                            <v-select v-model="item.planoContaId" label="Plano de Contas" :items="planoContas" item-value="id" item-text="descricao" :rules="fieldRules" :disabled="baixa" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="5">
                            <v-select v-model="item.planoContaItemId" label="Plano de Contas (Item)" :items="planoContaItens.filter(x => x.ativo == true || (x.ativo == false && x.id == item.planoContaItemId))" item-value="id" item-text="descricao" :rules="fieldRules" :disabled="baixa" dense outlined/>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="8">
                            <v-text-field v-model="item.descricao" label="Descrição" :rules="fieldRules" :disabled="baixa" :counter="60" maxlength="60" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-autocomplete v-model="item.bancoId" :items="bancos" item-text="codigoNome" item-value="id" label="Banco" :rules="fieldRules" dense outlined/>
                            <!-- <v-select v-model="item.bancoId" label="Banco" :items="bancos" item-value="id" item-text="nome" :rules="fieldRules" dense outlined/> -->
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="6">
                            <v-autocomplete v-model="item.doadorId" :items="doadores" :loading="isDoadorLoading" :search-input.sync="searchDoador" hide-no-data hide-selected cache-items clearable
                                item-text="cpfCnpjNome" item-value="id" label="Doador" :placeholder="item.doador ? item.doador.cpfCnpjNome : 'Digite um doador'" :disabled="baixa" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-autocomplete v-model="item.projetoId" :items="projetos" :loading="isProjetoLoading" :search-input.sync="searchProjeto" hide-no-data hide-selected cache-items clearable
                                item-text="codigoNome" item-value="id" label="Projeto" :placeholder="item.projeto ? item.projeto.codigoNome : 'Digite um projeto'" :disabled="baixa" dense outlined/>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="4">
                            <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                                <template v-slot:activator="{on}">
                                    <v-text-field type="date" v-model="item.dataLancamento" label="Lançamento" :rules="fieldRules" disabled dense outlined>
                                        <template v-slot:prepend>
                                            <v-icon v-on="on">mdi-calendar</v-icon>
                                        </template>
                                    </v-text-field>
                                </template>
                                <v-date-picker locale="pt-br" v-model="item.dataLancamento" no-title/>
                            </v-menu>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                                <template v-slot:activator="{on}">
                                    <v-text-field type="date" v-model="item.dataEmissao" label="Emissão" :rules="fieldRules" :disabled="baixa" dense outlined>
                                        <template v-slot:prepend>
                                            <v-icon v-on="on">mdi-calendar</v-icon>
                                        </template>
                                    </v-text-field>
                                </template>
                                <v-date-picker locale="pt-br" v-model="item.dataEmissao" no-title/>
                            </v-menu>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                                <template v-slot:activator="{on}">
                                    <v-text-field type="date" v-model="item.dataCompetencia" label="Competência" :rules="fieldRules" :disabled="baixa" dense outlined>
                                        <template v-slot:prepend>
                                            <v-icon v-on="on">mdi-calendar</v-icon>
                                        </template>
                                    </v-text-field>
                                </template>
                                <v-date-picker locale="pt-br" v-model="item.dataCompetencia" no-title/>
                            </v-menu>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                                <template v-slot:activator="{on}">
                                    <v-text-field type="date" v-model="item.dataVencimento" label="Vencimento" :rules="fieldRules" :disabled="baixa" dense outlined>
                                        <template v-slot:prepend>
                                            <v-icon v-on="on">mdi-calendar</v-icon>
                                        </template>
                                    </v-text-field>
                                </template>
                                <v-date-picker locale="pt-br" v-model="item.dataVencimento" no-title/>
                            </v-menu>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                                <template v-slot:activator="{on}">
                                    <v-text-field type="date" v-model="item.dataPagamento" label="Pagamento" :rules="baixa ? fieldRules : []" :disabled="!baixa" dense outlined>
                                        <template v-slot:prepend>
                                            <v-icon v-on="on">mdi-calendar</v-icon>
                                        </template>
                                    </v-text-field>
                                </template>
                                <v-date-picker locale="pt-br" v-model="item.dataPagamento" no-title/>
                            </v-menu>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="2">
                            <v-select v-model="item.formaPagamento" label="Forma Pagamento" :items="formaPagamentos" item-value="key" item-text="value" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="2">
                            <v-text-field type="number" v-model.number="item.valor" label="Valor" :rules="fieldRules" :disabled="baixa" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="2">
                            <v-text-field type="number" v-model.number="item.desconto" label="Desconto" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="2">
                            <v-text-field type="number" v-model.number="item.juros" label="Juros" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="2">
                            <v-text-field type="number" v-model.number="item.valorFinal" label="Valor Final" disabled dense outlined/> {{total}}
                        </v-col>
                        <v-col cols="12" md="2">
                            <v-switch v-model="item.enviado" label="Enviado" :disabled="baixa" dense/>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="6">
                            <v-textarea v-model="item.observacao" label="Observação" :counter="255" maxlength="255" dense outlined/>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
        </v-card>

        <v-overlay :value="salvando">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>


    </v-dialog>

</template>
<script>
import RecebivelService from '../../../core/services/financeiro/RecebivelService';
import FormaPagamentoEnumService from '../../../core/services/financeiro/FormaPagamentoEnumService';
import Recebivel from '../../../core/domain/financeiro/Recebivel';
import BancoService from '../../../core/services/financeiro/BancoService';
import PlanoContaService from '../../../core/services/financeiro/PlanoContaService';
import DoadorService from '../../../core/services/doacao/DoadorService';
import ProjetoService from '../../../core/services/projetos/ProjetoService';

export default {
    props:{
        item: {
            required: true
        },
        value: {},
        baixa: false
    },
    watch: { 
        item: function() { 
            if ('formCadastroRecebivel' in this.$refs)
                this.$refs.formCadastroRecebivel.resetValidation();
            
            if(this.item.doador)
                this.doadores.push(this.item.doador);

            this.projetos.push(this.item.projeto);
        },
        "item.planoContaId": function(){
            if (this.item.planoContaId > 0){
                let planoConta = this.planoContas.find(x => x.id == this.item.planoContaId);
                this.planoContaItens = planoConta.itens;

                if(!this.planoContaItens.find(x => x.id == this.item.planoContaItemId)){
                    this.item.planoContaItemId = null;
                }
            }
        },
        "item.projetoId" : function(){
            if(this.item.projetoId > 0){
                let projeto = this.projetos.find(x => x.id == this.item.projetoId);
                
                if(projeto)
                    this.item.projeto = projeto;
            }
        },
        "item.doadorId" : function(){
            if(this.item.doadorId > 0){
                let doador = this.doadores.find(x => x.id == this.item.doadorId);

                if(doador)
                    this.item.doador = doador;
            }
        },
        value: function() {
            this.dialog = this.value;
        },
        dialog: function() {
            if (this.dialog) {
                this.Carregar();
            }
            else{
                this.$emit('fechou');
            }
        },
        searchDoador (val) {
            if (this.isDoadorLoading) return;
            if (!val) return;
            // if (val.length < 3 ) return;
            
            this.isDoadorLoading = true
            let doadorService = new DoadorService();
            doadorService.AutoComplete(val)
                .then(
                    res => {
                        this.doadores = res.data;
                    },
                    err => this.$swal('Aviso', err.response.data, 'error')
                )
                .finally(() => (this.isDoadorLoading = false))
        },
        searchProjeto (val) {
            if (this.isProjetoLoading) return;
            if (!val) return;
            // if (val.length < 3 ) return;
            
            this.isProjetoLoading = true
            let projetoService = new ProjetoService();
            projetoService.AutoComplete(val)
                .then(
                    res => {
                        this.projetos = res.data;
                    },
                    err => this.$swal('Aviso', err.response.data, 'error')
                )
                .finally(() => (this.isProjetoLoading = false))
        },
    },
    data: () => ({
        service: new RecebivelService(),
        valid: true,
        dialog: false,
        isDoadorLoading: false,
        isProjetoLoading: false,
        formaPagamentos: [],
        bancos: [],
        planoContas: [],
        planoContaItens: [],
        doadores: [],
        projetos: [],
        searchDoador: null,
        searchProjeto: null,
        fieldRules: [
            v => !!v || 'Campo obrigatório'
        ],
        sessionApp: {},
        salvando: false
    }),
    methods: {
        save() {
            if (this.$refs.formCadastroRecebivel.validate()) {
                this.salvando = true;
                let modelo = new Recebivel(this.item);
                modelo.banco = null;
                if (this.baixa){
                    this.service.Baixar(modelo).then(
                        res => {
                            this.$swal('Aviso', 'Operação realizada com sucesso!', res.status == 201 || res.status == 200 ? 'success' : 'warning');
                            this.$emit('salvou');
                            this.close();
                        }, 
                        err =>  {
                            this.$swal('Aviso', err.response.data, err.response.status == 400 ? 'warning' : 'error');
                        }
                    ).finally(() => {
                        this.salvando = false;
                    });
                } 
                else {
                    this.service.Salvar(modelo).then(
                        res => {
                            this.$swal('Aviso', 'Operação realizada com sucesso!', res.status == 201 || res.status == 200 ? 'success' : 'warning');
                            this.$emit('salvou');
                            this.close();
                        }, 
                        err =>  {
                            this.$swal('Aviso', err.response.data, err.response.status == 400 ? 'warning' : 'error');
                        }
                    ).finally(() => {
                        this.salvando = false;
                    });
                }
            }
        },
        close() {
            this.dialog = false;
        },
        Carregar(){
            let formaPagamentoEnumService = new FormaPagamentoEnumService();
            formaPagamentoEnumService.Listar().then(
                res => {
                    this.formaPagamentos = res.data;
                },
                err => this.$swal('Aviso', err.message, 'error')
            );

            let bancoService = new BancoService();
            bancoService.Listar().then(
                res => {
                    let resultado = res.data.items;
                    this.bancos = resultado.sort(function(a,b){
                        if(a.nome > b.nome){
                            return 1;
                        }
                        if(a.nome < b.nome){
                            return -1;
                        }
                        return 0;
                    }).filter(x => x.situacao == "A");
                },
                err => this.$swal('Aviso', err.message, 'error')
            );

            let planoContaService = new PlanoContaService();
            planoContaService.ListarByTipo('R',"Itens.PlanoContaContabil, Itens.PlanoContaContabilLivre, Itens.PlanoContaContabilRestrito").then(
                res => {
                    this.planoContas = res.data.items;
                },
                err => this.$swal('Aviso', err.message, 'error')
            );
        }
    },
    beforeUpdate(){
        if (!this.dialog){
            this.$emit('fechou');
        }
    },
    computed:{
        total(){

            this.item.valorFinal = this.item.valor + this.item.juros - this.item.desconto;

        }
    },
    mounted() {

    }
}
</script>